var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcFilterApply20 = function SvgIcFilterApply20(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.267 3c.29 0 .508.145.654.436.145.218.072.509-.073.727l-5.344 6.303a4.5 4.5 0 1 1-1.43 6.952l-2.818-1.41c-.29-.146-.436-.364-.436-.654v-4.506L2.152 4.163c-.145-.218-.218-.509-.073-.727.146-.29.364-.436.654-.436zm-1.393 9.71-1.95 2.13-.84-.761a.659.659 0 0 0-.904.023l-.002.865a.646.646 0 0 0 .026.025l1.322 1.199a.66.66 0 0 0 .922-.042l2.39-2.609a.612.612 0 0 0-.054-.882.658.658 0 0 0-.91.052zm-.133-8.257H4.33l4.797 5.741c.073.073.145.29.145.436v4.288l.801.4a4.479 4.479 0 0 1 .652-3.27V10.63c0-.218.073-.363.146-.509l4.869-5.668z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#9CC100",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcFilterApply20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-filter-apply-20.b98935be9a1ebcc8d513bb452c80a3b1.svg";